import React from 'react';

const MenuSeparator = () => <li role="separator" />;

export default MenuSeparator;
